import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@core/styles/index.css";
// Initialiser i18n (core + namespace produit `forms` de cette app).
import "./i18n";

// Initialiser le monitoring (tag Sentry `app=form-polls` pour filtrer les erreurs)
import { initMonitoring } from "@core/lib/initMonitoring";
initMonitoring("form-polls");

// Déclarer le produit pour le système de support (KB + assistant du widget
// répondent "formulaires" et non "sondages de dates")
import { setSupportProduct } from "@core/services/supportProduct";
setSupportProduct("form");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// build trigger: redeploy staging pour fixes B1-B8 (v3 testait bundle périmé, ignoreCommand skip sur commits docs)
